import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';
const {Text} = Typography;
const Content = Layout;

const CWL = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>This protocol studies protein-DNA and protein-RNA interactions in a native electrophoresis gel for proteins. Using a binding buffer, it helps to determine if a protein is capable of binding to a given DNA or RNA sequence, and if more than one protein molecule is involved in the binding complex. By using aptamers with a fluorophore modification, it’s possible to see if two or more aptamers compete for the same binding site in the protein.<br/><br/><b>Goal:</b> To observe the interaction between our aptamers and the C-Reactive Protein by determining if they have affinity to each other and if the aptamers compete for the same binding site in the protein.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '90vh', background: 'transparent'}}>
              <iframe title="TecCCM: EMSA (2022) [English]" height="515" src="https://video.igem.org/videos/embed/8d2a3957-ebf5-4607-9243-1c1e88f87d5d" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
              <Content style={{width: '15vh', marginTop: '0vh', marginLeft: '54vh', background: 'transparent'}}><p><i>Go to pdf</i></p></Content>
              <a style={{width: 'fit-content', marginLeft: '58vh'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/wet-lab/pdfs/1-emsa.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
            </Content>
          </Layout>
        </Content>
        <Divider/>
      </Layout>
    </Layout>
  );
};

export default CWL;
